/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { locationSummarySchema } from './locationSummarySchema';
import { skillSummarySchema } from './skillSummarySchema';
import { teamSummarySchema } from './teamSummarySchema';

export const openPositionDetailResponseSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  description: z.string().nullish(),
  employmentType: z.enum(['EMPLOYEE', 'CONTRACTOR', 'PARTNER', 'ON_DEMAND', 'AI_AGENT']),
  filledByResourceId: z.int().nullish(),
  filledByResourceName: z.string().nullish(),
  hiredAt: z.iso.datetime().nullish(),
  id: z.int(),
  get location() {
    return z.union([locationSummarySchema, z.null()]).optional();
  },
  locationId: z.int().nullish(),
  name: z.string(),
  organizationId: z.string(),
  roleId: z.int(),
  roleName: z.string(),
  get skills() {
    return z.array(skillSummarySchema);
  },
  get teams() {
    return z.array(teamSummarySchema);
  },
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
